export default __webpack_public_path__ + "static/1-14e129c6491c925608e079a702e65584.jpg";